import {
  AdminPanelSettings,
  Assignment,
  AssignmentTurnedIn,
  CalendarTodayOutlined,
  Category,
  ChargingStation,
  ChecklistRtl,
  ControlCamera,
  DeleteOutline,
  Description,
  DirectionsBoatSharp,
  Functions,
  Group,
  Hub,
  Key as KeyIcon,
  LocationCity,
  LocationOn,
  MarkEmailUnread,
  MiscellaneousServices,
  PeopleOutline,
  // PlayArrow,
  PlaylistAddCheck,
  Public,
  PunchClockSharp,
  Sailing,
  Schema,
  SettingsInputComponent,
  Streetview,
  Summarize,
  SupervisedUserCircleRounded,
  SupportAgent,
  SvgIconComponent,
  Task,
  TaskAlt,
  Warehouse,
} from '@mui/icons-material'
import { IconType } from 'react-icons'
import { permissionValue } from 'src/enums/permissionValue'
import { isDynamicReportsEnabled } from 'src/feature-flags'
import { AppRoutesNavigation, AppRoutesRouter } from '../../app-routes'

export interface IAdminSidebarItems {
  name: string
  path?: (id: EntityId) => string
  icon: SvgIconComponent | IconType
  pathname?: string
  children?: Array<IAdminSidebarItems>
  permissions?: number[]
  /** Stable integration id linked to a DB feature row. */
  integrationKey?: string
}

export const customerSidebarItems = isGlobal => {
  if (isGlobal) {
    return [
      {
        name: 'service-stations',
        path: AppRoutesNavigation.Customer.serviceStations,
        icon: MiscellaneousServices,
        pathname: AppRoutesRouter.Customer.serviceStations,
      },
      {
        name: 'users',
        path: AppRoutesNavigation.Customer.users,
        icon: Group,
        pathname: AppRoutesRouter.Customer.users,
      },
      {
        name: 'deviations',
        path: AppRoutesNavigation.Customer.deviationsAdmin,
        icon: AssignmentTurnedIn,
        pathname: AppRoutesRouter.Customer.deviationsAdmin,
      },
      {
        name: 'api-access',
        path: AppRoutesNavigation.Customer.apiAccess,
        icon: KeyIcon,
        pathname: AppRoutesRouter.Customer.apiAccess,
      },
    ] as IAdminSidebarItems[]
  }
  return [
    {
      name: 'facilities',
      icon: LocationOn,
      permissions: [permissionValue.ClientAdminPermission],
      children: [
        {
          name: 'localities',
          path: AppRoutesNavigation.Customer.localities,
          icon: LocationCity,
          permissions: [permissionValue.ClientAdminPermission],
          pathname: AppRoutesRouter.Customer.localities,
        },
        {
          name: 'locality-groups',
          path: AppRoutesNavigation.Customer.localityGroups,
          icon: Streetview,
          pathname: AppRoutesRouter.Customer.localityGroup,
          permissions: [permissionValue.ClientAdminPermission],
        },
        {
          name: 'service-stations',
          path: AppRoutesNavigation.Customer.serviceStations,
          icon: MiscellaneousServices,
          pathname: AppRoutesRouter.Customer.serviceStations,
          permissions: [permissionValue.ClientAdminPermission],
        },
        {
          name: 'service-station-groups',
          path: AppRoutesNavigation.Customer.serviceStationGroup,
          icon: ChargingStation,
          pathname: AppRoutesRouter.Customer.serviceStationGroup,
          permissions: [permissionValue.ClientAdminPermission],
        },
        {
          name: 'storages',
          path: AppRoutesNavigation.Customer.storages,
          icon: Warehouse,
          pathname: AppRoutesRouter.Customer.storages,
          permissions: [permissionValue.ClientAdminPermission],
        },
        //Removed projects since customer admins do not need to assign users yet
        // {
        //   name: 'projects',
        //   path: AppRoutesNavigation.Customer.projects,
        //   icon: InsertInvitation,
        //   pathname: AppRoutesRouter.Customer.projects,
        // },
      ],
    },
    {
      name: 'access-control',
      icon: ControlCamera,
      permissions: [permissionValue.ClientAdminPermission],
      children: [
        {
          name: 'users',
          path: AppRoutesNavigation.Customer.users,
          icon: Group,
          pathname: AppRoutesRouter.Customer.users,
          permissions: [permissionValue.ClientAdminPermission],
        },
        {
          name: 'user-invites',
          path: AppRoutesNavigation.Customer.userInvites,
          icon: MarkEmailUnread,
          pathname: AppRoutesRouter.Customer.userInvites,
          permissions: [permissionValue.ClientAdminPermission],
        },
        {
          name: 'access-level-group',
          path: AppRoutesNavigation.Customer.accessControls,
          icon: SupportAgent,
          pathname: AppRoutesRouter.Customer.accessControls,
          permissions: [permissionValue.ClientAdminPermission],
        },
      ],
    },
    {
      name: 'services',
      path: AppRoutesNavigation.Customer.services,
      icon: SupportAgent,
      pathname: AppRoutesRouter.Customer.services,
      permissions: [permissionValue.ClientAdminPermission],
    },
    {
      name: 'custom-properties',
      path: AppRoutesNavigation.Customer.customProperty,
      icon: Functions,
      pathname: AppRoutesRouter.Customer.customProperty,
      permissions: [permissionValue.ClientAdminPermission],
    },
    {
      name: 'main-component-types',
      path: AppRoutesNavigation.Customer.mainComponentTypes,
      icon: SettingsInputComponent,
      pathname: AppRoutesRouter.Customer.mainComponentTypes,
      permissions: [permissionValue.ClientAdminPermission],
    },
    {
      name: 'schema',
      icon: Schema,
      permissions: [permissionValue.ClientAdminPermission],
      children: [
        {
          name: 'templates',
          path: AppRoutesNavigation.Customer.formSchema,
          icon: Description,
          pathname: AppRoutesRouter.Customer.formSchemas,
          permissions: [permissionValue.ClientAdminPermission],
        },
        {
          name: 'filled-forms',
          path: AppRoutesNavigation.Customer.formSchemaReports,
          icon: Assignment,
          pathname: AppRoutesRouter.Customer.formSchemaReports,
          permissions: [permissionValue.ClientAdminPermission],
        },
        ...(isDynamicReportsEnabled
          ? [
              {
                name: 'dynamic-reports',
                path: AppRoutesNavigation.Customer.dynamicReports,
                icon: Summarize,
                pathname: AppRoutesRouter.Customer.dynamicReports,
                permissions: [permissionValue.ClientAdminPermission],
              },
            ]
          : []),
        // TODO: Activity templates feature is unavailable at the moment
        // {
        //   name: 'activity-templates',
        //   path: AppRoutesNavigation.Customer.interactiveSchemas,
        //   icon: PlayArrow,
        //   pathname: AppRoutesRouter.Customer.interactiveSchemas,
        //   permissions: [permissionValue.ClientAdminPermission],
        // },
        {
          name: 'checklists',
          path: AppRoutesNavigation.Customer.checklists,
          icon: PlaylistAddCheck,
          pathname: AppRoutesRouter.Customer.checklists,
          permissions: [permissionValue.ClientAdminPermission],
        },
      ],
    },
    {
      name: 'checklist-templates',
      path: AppRoutesNavigation.Customer.checklistTemplates,
      icon: ChecklistRtl,
      pathname: AppRoutesRouter.Customer.checklistTemplates,
      permissions: [permissionValue.ClientAdminPermission],
    },
    {
      name: 'main-components',
      path: AppRoutesNavigation.Customer.mainComponents,
      icon: Hub,
      pathname: AppRoutesRouter.Customer.mainComponents,
      permissions: [permissionValue.ClientAdminPermission, permissionValue.ClientAdminPortal.Equipment_Portal],
    },
    {
      name: 'global-documents',
      icon: Public,
      permissions: [permissionValue.ClientAdminPermission],
      children: [
        {
          name: 'admin',
          path: AppRoutesNavigation.Customer.globalDocumentsAdmin,
          icon: AdminPanelSettings,
          pathname: AppRoutesRouter.Customer.globalDocumentsAdmin,
          permissions: [permissionValue.ClientAdminPermission],
        },
        {
          name: 'customer',
          path: AppRoutesNavigation.Customer.globalDocumentsCustomer,
          icon: SupervisedUserCircleRounded,
          pathname: AppRoutesRouter.Customer.globalDocumentsCustomer,
          permissions: [permissionValue.ClientAdminPermission],
        },
        {
          name: 'locality',
          path: AppRoutesNavigation.Customer.localityGlobalDocuments,
          icon: LocationCity,
          pathname: AppRoutesRouter.Customer.localityGlobalDocuments,
          permissions: [permissionValue.ClientAdminPermission],
        },
      ],
    },
    {
      name: 'suppliers',
      icon: PeopleOutline,
      path: AppRoutesNavigation.Customer.suppliers,
      pathname: AppRoutesRouter.Customer.suppliers,
      permissions: [permissionValue.ClientAdminPermission],
    },
    {
      name: 'expiring-components',
      icon: CalendarTodayOutlined,
      path: AppRoutesNavigation.Customer.componentOverview,
      pathname: AppRoutesRouter.Customer.componentOverview,
      permissions: [permissionValue.ClientAdminPermission],
    },
    {
      name: 'document-category',
      path: AppRoutesNavigation.Customer.documentCategories,
      icon: Category,
      pathname: AppRoutesRouter.Customer.documentCategories,
      permissions: [permissionValue.ClientAdminPermission],
    },
    {
      name: 'archived-documents',
      icon: DeleteOutline,
      path: AppRoutesNavigation.Customer.archivedDocuments,
      pathname: AppRoutesRouter.Customer.archivedDocuments,
      permissions: [permissionValue.ClientAdminPermission],
    },
    {
      name: 'api-access',
      path: AppRoutesNavigation.Customer.apiAccess,
      icon: KeyIcon,
      pathname: AppRoutesRouter.Customer.apiAccess,
    },
    {
      name: 'news',
      path: AppRoutesNavigation.Customer.newsAdmin,
      icon: Description,
      pathname: AppRoutesRouter.Customer.newsAdmin,
      permissions: [permissionValue.ClientAdminPermission, permissionValue.Locality.News.Write],
    },
    {
      name: 'deviations',
      path: AppRoutesNavigation.Customer.deviationsAdmin,
      icon: AssignmentTurnedIn,
      pathname: AppRoutesRouter.Customer.deviationsAdmin,
      permissions: [permissionValue.ClientAdminPermission],
    },
    {
      name: 'tasks',
      icon: Task,
      permissions: [permissionValue.ClientAdminPermission, permissionValue.ClientAdminPortal.Task_Portal],
      children: [
        {
          name: 'tasks',
          path: AppRoutesNavigation.Customer.workOrders,
          icon: TaskAlt,
          pathname: AppRoutesRouter.Customer.workOrders,
        },
        {
          name: 'resources',
          path: AppRoutesNavigation.Customer.vessels,
          icon: DirectionsBoatSharp,
          pathname: AppRoutesRouter.Customer.vessels,
        },
        {
          name: 'time-reports',
          path: AppRoutesNavigation.Customer.timeReports,
          icon: PunchClockSharp,
          pathname: AppRoutesRouter.Customer.timeReports,
          permissions: [permissionValue.ClientAdminPermission, permissionValue.ClientAdminPortal.Task_Portal],
        },
      ],
    },
    {
      name: 'ais-vessels',
      path: AppRoutesNavigation.Customer.aisVessels,
      icon: Sailing,
      pathname: AppRoutesRouter.Customer.aisVessels,
      permissions: [permissionValue.ClientAdminPermission],
    },
  ] as IAdminSidebarItems[]
}
